import styles from './choice.module.css';
import {Paragraph, Typography} from '@toppy-webshop/toppy-design-system';
import clsx from 'clsx';

interface ChoiceProps {
    onClick: (choice: unknown) => void;
    choice: unknown;
    label: string;
    description?: null | string;
    checked: boolean;
    disabled?: boolean;
    outline?: boolean;
}

const Choice = ({
    onClick,
    choice,
    label,
    description,
    checked,
    disabled = false,
    outline = false,
}: ChoiceProps) => {
    return (
        <div
            onClick={() => onClick(choice)}
            className={clsx(styles.choice, outline && styles.choice__outline)}
        >
            <div className={styles.choice__input}>
                <input
                    type={'radio'}
                    disabled={disabled}
                    checked={checked}
                    readOnly={true}
                />{' '}
            </div>
            <div className={styles.choice__body}>
                <Typography component={'div'}>{label}</Typography>
                {description && <Paragraph light>{description}</Paragraph>}
            </div>
        </div>
    );
};

export default Choice;
